import { gql } from '@apollo/client';

const CHANGE_PASSWORD = gql`
  mutation changePassword($oldPassword: String!, $newPassword: String!) {
    changePassword(oldPass: $oldPassword, newPass: $newPassword)
  }
`;

export { CHANGE_PASSWORD };
